import { FileTab } from './FileTab'
import { connect } from 'react-redux'

const mapStateToProps = (state: { activeBot }) => ({
  activeBot: state.activeBot,
})

export default connect(mapStateToProps)(FileTab)
